import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Select } from 'foundations-components/components/Select';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { setErrorMessages, getShowAllErrors } from '../../state/errorMessagesSlice';
import I18n from 'I18n';
import { useGetErrorMessagesAndTranslations } from '../../hooks/useGetErrorMessagesAndTranslations';
import { jsx as _jsx } from "react/jsx-runtime";
const findInStates = (searchQuery, states) => {
  return states.find(({
    text: optionText,
    value: optionValue
  }) => searchQuery.toUpperCase() === optionText.toUpperCase() || searchQuery.toUpperCase() === optionValue.toUpperCase());
};
const FullAddressAdminArea = ({
  disabled,
  isUS,
  onChange,
  states,
  initialValue,
  isShippingAddress = false
}) => {
  const dispatch = useDispatch();
  const showAllErrors = useSelector(getShowAllErrors);
  const [hasBeenBlurred, setHasBeenBlurred] = useState(false);
  const isError = (hasBeenBlurred || showAllErrors) && !initialValue;
  const usErrorKey = isShippingAddress ? 'emptyShippingState' : 'emptyBillingState';
  const nonUsErrorKey = isShippingAddress ? 'emptyShippingStateProvinceRegion' : 'emptyBillingStateProvinceRegion';
  useEffect(() => {
    dispatch(setErrorMessages({
      [usErrorKey]: {
        isError: isUS && isError
      },
      [nonUsErrorKey]: {
        isError: !isUS && isError
      }
    }));
  }, [isError, dispatch, isUS, usErrorKey, nonUsErrorKey]);
  const errorMessage = useGetErrorMessagesAndTranslations().get(isUS ? 'emptyState' : 'emptyStateProvinceRegion');
  const handleInputChange = useCallback(({
    value
  }) => {
    const dropdownMatch = findInStates(value, states);
    if (dropdownMatch) {
      const event = syntheticEvent(dropdownMatch.value);
      onChange(event);
    }
  }, [onChange, states]);
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: isUS ? 'payments.fullAddress.state' : 'payments.fullAddress.stateProvinceRegion'
    }),
    required: true,
    "data-test-id": "admin-area-field",
    error: isError,
    validationMessage: isError && errorMessage,
    children: states.length > 0 ? /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(Select, {
        error: isError,
        referenceVariant: "on-dark",
        "data-test-id": "full-address-fields-states-dropdown",
        options: states,
        onSelectedOptionChange: handleInputChange,
        selectedValues: [initialValue],
        disabled: disabled,
        selectedItemsPlaceholder: I18n.text('payments.fullAddress.chooseOne'),
        onOpenChange: isOpen => {
          if (!isOpen) {
            setHasBeenBlurred(true);
          }
        }
      })
    }) : /*#__PURE__*/_jsx(TextInput, {
      error: isError,
      "data-test-id": "full-address-fields-states-input",
      name: "state",
      disabled: disabled,
      onChange: onChange,
      value: initialValue,
      use: "on-dark",
      onBlur: () => setHasBeenBlurred(true)
    })
  });
};
export default FullAddressAdminArea;